// extracted by css-extract-rspack-plugin
export default {"heading":"heading-GeU1cE","paragraph":"paragraph-Yy0GZq","list":"list-eBvAaD","listItem":"listItem-PQrZ2e","text":"text-uZrBQs","button":"button-AMlEeJ","btn":"btn-oH6dua"};